<div class="grid">
    
    <div class="title">{{ title }}</div>
    <div>
        <span [innerHTML]="htmlMessage"></span>
    </div>

    <button mat-button (click)="closeClick($event)">Fechar</button>

</div>